<template>

  <div class="d-inline-flex">
    <div v-if="this.mode=='button'">
      <!-- VTT Popup-->
      <v-dialog v-model="vttNoActiveModel" max-width="400px" persistent>
        <v-card class="px-5 py-10" rounded="lg">
          <v-card-text>
            <slot>
              <h2 class="text-center">
                {{ vttErrorText }}
              </h2>
            </slot>
          </v-card-text>
          <v-card-actions class="d-flex justify-center">
            <!-- Confirm Btn -->
            <v-btn
              rounded
              depressed
              color="primary"
              width="100px"
              class="mx-3"
              @click="vttNoActiveModel = false"
            >
              Ok
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- VTT Popup-->

      <v-btn
        style="box-shadow: -4px 4px 10px #777 !important; margin-left: 10px"
        rounded
        :color="isVTTEnabled ? 'success' : 'danger'"
        @click="setVTTStatus()"
        depressed
        class="text-none text-gray"
      >
        <v-icon>mdi-microphone</v-icon>
        <h2 style="margin-left: 5px">
          {{ isVTTEnabled ? "Disable VTT" : "Enable VTT" }}
        </h2>
      </v-btn>
    </div>
    <div v-if="this.mode=='checkbox'">
      <v-row>
        <v-col cols="12">        
          <v-checkbox dense hide-details value="vttenabled" v-model="vttcheckBox" class="mt-0 text-primary" label="Enable VTT on this form" @click="setVTTStatus"></v-checkbox>        
          <span class="red--text" v-if="this.vttErrorText != ''">{{ this.vttErrorText }}</span>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
export default {
  name: "VTTButton",
  props: ['mode'],
  data: () => ({
    vttNoActiveModel: false,
    vttErrorText: "",
    vttcheckBox: []
  }),
  computed: {
    isVTTEnabled: {
      get() {
        return this.$store.getters["vtt/isEnabled"];
      },
      set(val) {
        this.$store.commit("vtt/setStatus", val);
      },
    },
    consultation() { return this.$store.getters['consultation/activeInfo'] },
  },
  methods: {
    async setVTTStatus() {
      let currentStatus = this.isVTTEnabled;
      let error = this.$vtt.checkErrors();

      console.log('Error: ', error);

      if (error !== false && !currentStatus) {
        this.vttNoActiveModel = true;
        this.vttErrorText = error;
        this.vttcheckBox = [];
        return false;
      }

      if (!currentStatus) {
        this.$vtt.on("streamStop", (params) => {
          console.log("stopped: ", params);
          this.vttcheckBox = [];
          this.$store.commit("vtt/setStatus", false);
        });

        console.log(this.consultation);

        currentStatus = await this.$vtt.startStream(this.consultation.id);
        this.$store.commit("vtt/setStatus", currentStatus);
        this.vttcheckBox = ['vttenabled'];
        this.vttErrorText = '';
      } else {
        this.$vtt.stopStream();
        this.$store.commit("vtt/setStatus", false);
        this.vttcheckBox = [];
      }
    },
  },
};
</script>